import React, { memo, useState, useCallback } from "react";
import { useSelector } from "react-redux";

import * as Styled from "./styled";
import {Alert, Button, Form, Input} from "antd";
import {getDataLoading} from "../../../store/settings/settingsSelector";
import {withTranslation} from "react-i18next";

export default withTranslation()(memo(({ t, values, onLogin, onInputChange, isSubmitDisabled }) => {
  const auth = useSelector((state) => state.auth);
  const loading = useSelector(getDataLoading);

  const handleConfirmClick = (e) => {
    e.preventDefault();
    onLogin();
  };
  const handleKeyDown = e => {
    if (e.key === 'Enter' && !isSubmitDisabled) {
      onLogin();
    }
  }

  return (
        <Styled.SigninForm>
          <Styled.SigninHeader>{t("Login")}</Styled.SigninHeader>
          <Styled.SigninBody>
            <Form
              layout="vertical"
              autoComplete="off"
            >
              {/*{
                auth && auth.error &&
                <Styled.SigninError>
                  <Alert
                    message={auth.errorMessage}
                    type="error"
                    //closable
                  />
                </Styled.SigninError>
              }*/}

              <Form.Item
                name={'username'}
                //label={"User Name"}
              >
                <Styled.SigninInput
                  autoComplete={'usernameInput'}
                  onChange={onInputChange}
                  name={'username'}
                  value={values.username}
                  allowClear
                  placeholder={t("Enter user name")}
                />
              </Form.Item>
              <Form.Item
                name={'password'}
              >
                <Styled.SigninPasswordInput
                  autoComplete={'passwordInput'}
                  onChange={onInputChange}
                  value={values.password}
                  placeholder={t("Enter password")}
                  name={'password'}
                  onKeyDown={handleKeyDown}
                />
              </Form.Item>
            </Form>
          </Styled.SigninBody>
          <Styled.SigninFooter>
            <Styled.SigninButton
              key="loginButton"
              type={"primary"}
              onClick={handleConfirmClick}
              disabled={isSubmitDisabled}
              loading={loading}
            >{t("Login")}</Styled.SigninButton>
          </Styled.SigninFooter>
        </Styled.SigninForm>
  );
}));
